<template>
  <div class="image-container">
    <div class="ao__aside">
      <img
        v-if="props.src && !imageNotFound"
        loading="lazy"
        class="object-cover h-full w-full"
        :src="String(props.src)"
        :alt="props.alt || ''"
        @error="onError"
      />
      <img
        v-else
        class="object-cover h-full w-full"
        loading="lazy"
        :src="getNotFoundImage()"
        :alt="props.alt || ''"
      />
    </div>
    <div v-if="props.caption || props.source" class="image-container__caption">
      <span v-if="props.caption" class="image-container__title">{{ props.caption }}</span>
      <span v-if="props.caption && props.source" class="image-container__divider" />
      <span v-if="props.source" class="image-container__source">{{ $t('artobjects.source') }}: {{ props.source }}</span>
    </div>
  </div>

</template>

<script setup lang="ts">
import type {Maybe} from "@graphql-tools/utils"

import defaultNotFound from 'assets/images/default/not-found.png'
import poggersNotFound from 'assets/images/poggers/not-found.png'
import materidouskaNotFound from 'assets/images/materidouska/not-found.png'

import {useUniWebTemplate} from "~/composables/useUniWebTemplate";
import {TemplateList} from "~/libs/constants/TemplateList";

const props = defineProps<{
  src?: Maybe<string>,
  source?: Maybe<string>,
  caption?: Maybe<string>,
  alt?: Maybe<string>
}>()

const template = useUniWebTemplate()
const imageNotFound = ref(false)

const getNotFoundImage = () => {
  switch (template.uniWebTemplateNameLowerCase) {
    case TemplateList.MATERIDOUSKA:
      return materidouskaNotFound
    case TemplateList.POGGERS:
      return poggersNotFound
    default:
      return defaultNotFound
  }
}

const onError = (e) => {
  imageNotFound.value = true
}
</script>
